"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useEmitTypingIndicator;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useEmitTypingIndicator() {
  return (0, _useWebChatAPIContext.default)().emitTypingIndicator;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VFbWl0VHlwaW5nSW5kaWNhdG9yIiwidXNlV2ViQ2hhdEFQSUNvbnRleHQiLCJlbWl0VHlwaW5nSW5kaWNhdG9yIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlRW1pdFR5cGluZ0luZGljYXRvci50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUVtaXRUeXBpbmdJbmRpY2F0b3IoKTogKCkgPT4gdm9pZCB7XG4gIHJldHVybiB1c2VXZWJDaGF0QVBJQ29udGV4dCgpLmVtaXRUeXBpbmdJbmRpY2F0b3I7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLHNCQUFULEdBQThDO0VBQzNELE9BQU8sSUFBQUMsNkJBQUEsSUFBdUJDLG1CQUE5QjtBQUNEIn0=